import {format, subMonths} from "date-fns";
export const DETAIL_TITLES = {
    BOOK_CLOSURE: 'Book closure',
    AGM: 'AGM',
    EGM: 'EGM',
    SPLIT: 'Split',
    BONUS: 'Bonus',
    RIGHTS: 'Rights',
    BUY_BACK: 'Buy Back',
    BOARD_MEETINGS: 'Board Meeting',
};

export const getLastSixMonthDate = () => {
    const currentDate = format(new Date(), 'MM-LLL-yyyy');
    const lastSixMonth = subMonths(new Date(), 3);
    const lastDate = format(lastSixMonth, 'MM-LLL-yyyy');
    return {
        toDate: currentDate,
        fromDate: lastDate,
    };
};
